module.exports = __webpack_public_path__ + "static/beach-dba9283c21fb5a774982bbc24fd1204f.png";